export const getLocalStorage = () => {
    let data = {
    // guid: localStorage.getItem('guid'),
    // token: localStorage.getItem("token"),
    // admin_token: localStorage.getItem("admin_token"),
    // admin: localStorage.getItem("admin"),
    // mtd: localStorage.getItem("mtd"),
    // has_sub: localStorage.getItem("has_sub"),
    // in_trial: localStorage.getItem('in_trial'),
    // plan: localStorage.getItem('plan'),
    // sub_active: localStorage.getItem('subscription_active'),
    // username: localStorage.getItem("username"),
    // agent: localStorage.getItem('agent'),
    // logged_in: localStorage.getItem('logged_in'),
    // support_token_start: localStorage.getItem('support_token_start'),
    // users: localStorage.getItem("users"),
    logged_in: localStorage.getItem('logged_in'),
    agent: localStorage.getItem('agent'),
    username: localStorage.getItem("agent_username"),
    users: localStorage.getItem("users"),
    // secret: localStorage.getItem("secret"),
    agentToken: localStorage.getItem("agentToken"),
    agent_code: localStorage.getItem("agent_code"),
    name: localStorage.getItem("agent_name"),
    user_email_required: localStorage.getItem("user_email_required"),
    require_acceptance: localStorage.getItem("require_acceptance")
    }
    return data
}
